{
  "Approve": "同意",
  "DeleteReminder": "删除提醒",
  "DismissAlert": "取消",
  "DismissReminder": "取消提醒",
  "Earlier": "更早",
  "EditReminder": "编辑提醒",
  "High": "高",
  "MarkAllAsRead": "全部标记为已读",
  "Reject": "拒绝",
  "RemindMe15Min": "15 分钟后提醒我",
  "RemindMe5Min": "5 分钟后提醒我",
  "RemindMe60Min": "1 小时后提醒我",
  "RemindMeTomorrow": "明天提醒我",
  "Snooze": "提醒我",
  "markAsRead": "标记为已读",
  "markAsUnread": "标记为未读",
  "noNotifications": "您将收到有关我们产品、与其他用户的合作以及其他相关更新的重要信息。",
  "noNotificationsTitle": "将在此处显示您的通知"
}
